<div [class]="'rounded p-4 flex gap-3 items-center ' + statusClass + getBackgroundClass()">
  <img [src]="'./assets/icons/' + getIcon() + '.svg'" alt="Agenda" class="w-6 h-6 inline-block" />
  <div class="flex flex-col">
    <h4>{{ getName() }}</h4>
    <h5 class="text-sm text-opacity-60">
      {{ consulta.appointmentDate | date: 'hh:mm' }} - {{ dataFimConsulta | date: 'hh:mm' }}
    </h5>
  </div>
  <button
    *ngIf="isAppointmentNow && isAppointmentOnline()"
    class="p-2 btn btn--primary h-auto bg-white text-chathams-blue"
    (click)="entrarConsulta()"
  >
    Entrar
  </button>
</div>
